export const GLOBAL_STATE = 'AssessmentEC'

export const ASSESSMENT_EC = 'assessmentEC'
export const ASSESSMENT_EC_CREATE = 'assessmentECCreate'
export const ASSESSMENT_EC_PAPER = 'assessmentECPaper'
export const ASSESSMENT_EC_UPDATE = 'assessmentECUpdate'
export const ASSESSMENT_EC_OUTCOME_REPORT = 'assessmentECOutcomeReport'
export const ASSESSMENT_EC_ALL = 'assessmentECAll'
export const ASSESSMENT_EC_STATUS = 'assessmentECStatus'
